import React from 'react'
import ApprovalInboxV2Container from '../../containers/approvalmng/ApprovalInboxV2Container'

const ApprovalListPage = () => {
  return <ApprovalInboxV2Container/>
}

export default ApprovalListPage
